import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
import type { Community } from '../types';

/** One interest community: cover, name, activity, and join / joined. */
export function CommunityRow({
  community
}: {
  community: Community;
}) {
  const {
    t,
    tl,
    locale
  } = useLocale();
  const navigate = useNavigate();
  const social = useSocial();
  const member = social.isMember(community.id);
  const members = social.memberCount(community.id).toLocaleString(locale);
  return <li className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-629" data-mp="3qj9g7c6j95sr">
      <button type="button" onClick={() => navigate(`/comunidade/c/${community.id}`)} className="flex min-w-0 flex-1 items-center gap-2 text-left" data-id="element-630" data-mp="3vicjos6v73ym">
        <img src={community.cover} alt="" aria-hidden="true" className="h-12 w-12 shrink-0 rounded-[14px] object-cover" data-id="element-631" data-mp="2k4ql6gf47q0f" />
        <span className="min-w-0 flex-1" data-id="element-632" data-mp="3mp4wt06c1j9d">
          <span className="block truncate text-[13.5px] font-medium text-deep" data-id="element-633" data-mp="3hoyy501nawhs">
            {tl(community.name)}
          </span>
          <span className="bee-num mt-[2px] block truncate text-[11px] text-muted" data-id="element-634" data-mp="3vp9togdwgz9a">
            {t('community.members', {
            n: members
          })} ·{' '}
            {t('community.weekly', {
            n: community.postsThisWeek
          })}
          </span>
        </span>
      </button>
      <button type="button" onClick={() => social.toggleMembership(community.id)} aria-pressed={member} className={`flex min-h-[36px] shrink-0 items-center gap-1 rounded-pill border px-2 text-[11.5px] font-medium transition-colors duration-150 ease-brand ${member ? 'border-gold/55 bg-white/70 text-deep' : 'border-deep bg-deep text-sand hover:bg-soft'}`} data-id="element-635" data-mp="4i6zdg2rmcuu">
        {member && <CheckIcon size={13} className="text-gold-deep" aria-hidden="true" data-id="element-636" data-mp="n629mpz658j7" />}
        {member ? t('community.joined') : t('community.join')}
      </button>
    </li>;
}